import Image from 'next/legacy/image';
import React, { useContext } from 'react';
import arrowDown from '@assets/images/arrow-down-white-2.svg';
import arrowDownBlack from '@assets/images/arrow-down.svg';
import arrowUp from '@assets/images/arrow-up.svg';
import AccordionContext from '@context/AccordionContext';
import styles from '@components/DynamicLandingPages/pure.module.css';

type TitleProps = {
  children: JSX.Element | string;
  buttonClass?: string;
  isArrowBlack?: boolean;
  onClick?: () => void;
};

function Title({ buttonClass, children, isArrowBlack, onClick }: TitleProps) {
  const { dispatch, state } = useContext(AccordionContext);

  return (
    <button
      type="button"
      className={`${buttonClass} flex items-center justify-between gap-4`}
      onClick={() => {
        dispatch({ type: 'TOGGLE' });
        if (onClick) {
          onClick();
        }
      }}
    >
      {children}
      <div className={`flex-shrink-0 flex-grow-0 ${styles['basis-0']}`}>
        <Image
          // eslint-disable-next-line no-nested-ternary
          src={isArrowBlack ? (state.isOpen ? arrowUp : arrowDownBlack) : arrowDown}
          alt={isArrowBlack ? 'arrow' : 'show more'}
          className={!isArrowBlack ? `${state.isOpen ? 'rotate-180 transform' : ''}` : ''}
          width={12}
          height={isArrowBlack ? 12 : 6}
        />
      </div>
    </button>
  );
}

Title.defaultProps = {
  buttonClass: '',
  isArrowBlack: false,
  onClick: () => {},
};

export default Title;
